export default class PageAccordions {
  constructor(selector) {
    this.accordions = $(selector);
    this.expandedByDefault = $(`${selector}.section.open`);
    this.expandDefault();
  }

  expandAll() {
    this.accordions
      .find('> .panel > .panel-body')
      .addClass('in')
      .attr('aria-expanded', 'true')
      .css('height', '');
    this.accordions.find('> .panel > .panel-heading').addClass('active');
  }

  collapseAll() {
    this.accordions
      .find('> .panel > .panel-body')
      .removeClass('in')
      .attr('aria-expanded', 'false')
      .css('height', '0');
    this.accordions.find('> .panel > .panel-heading').removeClass('active');
  }

  expandDefault() {
    this.expandedByDefault
      .find('> .panel > .panel-body')
      .addClass('in')
      .attr('aria-expanded', 'true')
      .css('height', '');
    this.expandedByDefault.find('> .panel > .panel-heading').addClass('active');
  }
}
